<template>
  <div class>
    <!-- header start -->

    <div v-if="isAdd">
      <van-nav-bar
      title="追忆文章"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :border="false"
    >
      <template #right>
        <i class="fa fa-plus-square" aria-hidden="true"></i>
      </template>
    </van-nav-bar>
    </div>
    <div v-else >
      <van-nav-bar
      title="追忆文章"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
    </van-nav-bar>
    </div>

    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div v-for="(item,index) in dataList" :key="index">
          <div>
            <router-link
              class="memory-list van-hairline--bottom"
              :to="{path:'/MemoryDetails', query:{id:item.SerialNumber,memorialArticleID:item.MemorialArticleID}}"
            >
              <div class="hd">
                <div class="image">
                  <van-image radius="2" fit="cover" :src="item.CoverPhoto" />
                </div>
              </div>
              <div class="bd">
                <h2 class="title">{{item.Title}}</h2>
                <p class="date">{{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</p>

                <div
                  v-if="currentToken.isLogin&&currentToken.memberID == item.MemberApiModel.MemberID"
                  class="status"
                >
                  审核状态:
                  <span
                    v-if="item.ApproveStatus == 1"
                    style="color: Green"
                  >{{GetApproveStatuText(item.ApproveStatus)}}</span>
                  <span v-else style="color: red">{{GetApproveStatuText(item.ApproveStatus)}}</span>
                </div>
                <p class="des van-multi-ellipsis--l2" v-html="item.Introduction"></p>
              </div>
            </router-link>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- <div>
      <router-link class="memory-list van-hairline--bottom" to="/MemoryDetails" v-for="item in 3" :key="item.id">
        <div class="hd">
          <div class="image">
            <van-image
              radius="2"
              fit="cover"
              src="https://img.yzcdn.cn/vant/cat.jpeg"
            />
          </div>
        </div>
        <div class="bd">
          <h2 class="title">彼岸花</h2>
    <p class="date">2020-02-19</p>-->
    <!-- <div class="status">审核状态:<span style="color: red">新添加</span></div> -->
    <!-- <p class="des van-multi-ellipsis--l2"> 相传以前有两个人名字分别叫做彼和岸，上天规定他们两个永不能相见。他们心心相惜，互相倾慕</p>
        </div>
      </router-link>
    </div>-->
  </div>
</template>

<script>
import { Toast } from "vant";
import { mapGetters } from "vuex";
import auth from "../../../tools/auth";

export default {
  data() {
    return {
      id: 0,
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: [],
      isSelf: false,
      isAdd:true
    };
  },
  computed: {
    ...mapGetters(["currentToken"])
  },
  components: {},
  methods: {
    onClickLeft() {
      // this.$router.go(-1);
      this.$back();
    },
    onClickRight() {
      this.$router.push("/MemoryAdd");
    },
    init() {
      var that = this;
      that.options = {
        type: "GetMemorialArticleMemorialArticleSearch",
        pageIndex: 1,
        id: this.id
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        res => {
          // console.log(res);
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.MemorialArticleAPiModelList;
          if (dataList.length <= 0) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = dataList;
          }
        },
        error => {}
      );
    },
    GetApproveStatuText(approveStatus) {
      var _text = "";
      switch (approveStatus) {
        case 0:
          _text = "新添加";
          break;
        case 1:
          _text = "审核通过";
          break;
        case 2:
          _text = "审核驳回";
          break;
        case 3:
          _text = "已编辑";
          break;
        default:
          _text = "新添加";
          break;
      }
      return _text;
    },
    getMemorialHall(id){
      var that = this;
      that.$store
        .dispatch({
          type: "GetMemorialHallSearchApiById",
          id: id
        })
        .then(
          (res) => {
            var memorialHallapiModel = res.MemorialHallSearchApiModel;
     
            if (memorialHallapiModel.IsPrivacy) {
              var _id = memorialHallapiModel.SerialNumber;
              auth.IsFriend(this, _id);
            }
            if(memorialHallapiModel.MemorialHallType==1)
            {
              that.isAdd=true;
            }
            else{
              that.isAdd=false;
            }
          },
          (err) => {}
        );
    }
  },
  activated(){
    var that = this;
    this.id = this.$route.query.id;
    this.getMemorialHall(this.id);
    that.init();
  },
  created() {
    // var that = this;
    // this.id = this.$route.query.id;
    // that.init();
  }
};
</script>

<style scoped>
.memory-list {
  padding: 15px;
  width: 100%;
  display: flex;
  align-items: flex-start;
}
.memory-list > .hd {
  width: 85px;
  height: 85px;
  margin-right: 15px;
}
.memory-list > .bd {
  flex: 1;
  overflow: hidden;
}
.memory-list > .bd > .title {
  font-weight: normal;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #444;
}
.memory-list > .bd > .date {
  font-size: 12px;
  color: #aaa;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 3px;
}
.memory-list > .bd > .status {
  font-size: 13px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: orange;
}
.memory-list > .bd > .des {
  font-size: 13px;
  color: #666;
}
</style>
